import(/* webpackMode: "eager" */ "/Users/martina/Desktop/stg-temp-0106v2/app/global-error.tsx");
